import React from "react";
import { Path } from "enums";
import { Route, Switch, Redirect } from "react-router-dom";
import CashInModule from "modules/cash-flow/cashin/cashin.module";
import ManualCashinModule from "modules/cash-flow/cashin/manual-cashin.module";

const CashFlowPage = () => {
  return (
    <Switch>
      <Route exact path={Path.ManualCashIn} component={ManualCashinModule} />
      <Route exact path={Path.CashIn} component={CashInModule} />
      <Redirect to={Path.CashIn} />
    </Switch>
  );
};

export default CashFlowPage;
